// @flow

import type { BootstrapConfig } from '../../../application-config/types/BootstrapConfig';

export const initAceAnalytics = (bootstrap: BootstrapConfig) => {
  if (!window.ace) return;

  window.ace.analytics.Initializer.initWithPageAnalytics(
    bootstrap.analytics.aceAnalytics.writeKey,
    {
      featureFlags: bootstrap.featureFlags,
      poweredBy: 'AMKT_FRONTEND',
      gasv3Product: 'marketplace',
    }
  );
};
